import { ResultModel } from '../models/result.model'
import { UserSettingsModel } from '../shared/models/service-models/UserSettings.model'
import RequestFactory from './RequestFactory'

const GMAE2EURL = process.env.REACT_APP_GMAE2E_URL
const UserSettingsService = {
  getByEmails: async (emails: string[]) =>
    (await RequestFactory.post(GMAE2EURL, '/api/user-settings/by-emails', emails)) as Promise<
      ResultModel<UserSettingsModel[]>
    >,
}

export default UserSettingsService
